<template>
  <v-content class="view-container">
    <navbar-app />
    <v-container :class="{'pt-7': !$mobileDetect.phone()}">
      <v-row>
        <v-col
          xl="6"
          offset-xl="3"
          md="8"
          offset-md="2"
        >
          <edit-password-form
            :class="{'mt-4 pa-3': !$mobileDetect.phone(), 'pa-2': $mobileDetect.phone()}"
            :old-password-needed="true"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>
<script>
  export default {
    name: 'Account',
    components: {
      NavbarApp: () => import('../components/App/NavbarApp'),
      EditPasswordForm: () => import('../components/Account/EditPasswordForm'),
    },
  }
</script>
